module.exports = __webpack_public_path__ + "img/Hero@2x.43c0a916.png";